import { facebookConversionTypes as Type } from '../../types/facebook-conversion';

export function facebookSendEvent(
  eventType: string,
  userData: any,
  customData: any,
) {
  const formatPhoneNumber = (phone: string): string | null => {
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `+1${cleaned}`;
    } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
      return `+${cleaned}`;
    }
    return null;
  };

  const { phone, ...userDataWithoutPhone } = userData || {};
  const formattedUserData = { ...userDataWithoutPhone };

  if (phone) {
    const formattedPhone = formatPhoneNumber(phone);
    if (formattedPhone) {
      formattedUserData.phone = formattedPhone;
    }
  }

  return {
    type: Type.FACEBOOK_EVENT_REQUEST,
    eventType: eventType,
    userData: formattedUserData,
    customData: customData,
  };
}
export function facebookSendEventSuccess() {
  return {
    type: Type.FACEBOOK_EVENT_SUCCESS,
  };
}

export function facebookSendEventFailure(error: any) {
  return {
    type: Type.FACEBOOK_EVENT_FAILURE,
  };
}
